'use client';

import { useCompanyMembers } from '@commenda/api';
import {
  Avatar,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { filterCommendaIoEmails } from '@commenda/utils';
import { LabelWithGuidanceTooltip } from '../../../form-builder/components/wrappers/LabelWithGuidanceTooltip';
import { WizardModuleCard } from './WizardModuleCard';

/**
 * Part 4 — pick who the generated compliance work is assigned to. At least one
 * assignee is required to finish (enforced by the renderer). Mirrors
 * ComplianceOnboardingSelectDefaultAssignee's member-fetch logic.
 */
export const Part4Assignee = ({
  companyId,
  selectedMemberId,
  onSelectMembers,
}: {
  companyId: number;
  selectedMemberId: string;
  onSelectMembers: (members: string[]) => void;
}) => {
  const { data: companyMembers } = useCompanyMembers(companyId);
  const filteredMembers = filterCommendaIoEmails(
    companyMembers?.members,
    companyId
  );

  return (
    <WizardModuleCard
      title="Select default assignee"
      description="At least one team member receives all related notifications. You can re-assign any filing later."
    >
      <div className="mb-4">
        <LabelWithGuidanceTooltip label="Select a member" isRequired />
        <Select
          value={selectedMemberId}
          onValueChange={(value) => onSelectMembers([value])}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select a team member" />
          </SelectTrigger>
          <SelectContent>
            {filteredMembers.map((member) => (
              <SelectItem key={member.id} value={member.id}>
                <div className="flex items-center gap-2">
                  <Avatar size="xs" name={member.name} />
                  <span>{member.name}</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </WizardModuleCard>
  );
};
